import { httpClient } from "../../../../services/httpClient";

export const fetchFrontendLogs = (params = {}) => {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      searchParams.append(key, value);
    }
  });

  const query = searchParams.toString();
  const path = `/api/logs/frontend${query ? `?${query}` : ""}`;
  return httpClient.get(path);
};

const frontendLogsService = {
  fetch: fetchFrontendLogs,
};

export default frontendLogsService;
